import { Routes } from '@angular/router';
import { HomeComponent } from './pages/home/home.component';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { HelpComponent } from './pages/help/help.component';
import { InfoComponent } from './pages/info/info.component';
import { LocationComponent } from './pages/location/location.component';
import { LocationsComponent } from './pages/locations/locations.component';
import { OfferComponent } from './pages/offer/offer.component';
import { OffersComponent } from './pages/offers/offers.component';
import { FullComponent } from './layouts/full/full.component';

export const routes: Routes = [
  {
    path: '',
    component: FullComponent,
    children: [
      { path: '', component: HomeComponent },
      { path: 'proposte', component: OffersComponent },
      { path: 'proposta/:id', component: OfferComponent },
      { path: 'sedi', component: LocationsComponent },
      { path: 'sede/:id', component: LocationComponent },
      { path: 'help', component: HelpComponent },
      { path: 'info', component: InfoComponent },
      { path: 'error', component: ErrorPageComponent },
    ]
  }
];
